import { Building2, Monitor, Shield, Zap, Download, ExternalLink, ChevronRight } from 'lucide-react';

/**
 * DownloadPage — Pagina premium para download do demo Windows.
 * O EXE e hospedado no GitHub Releases do repositorio.
 */

const DOWNLOAD_URL = 'https://aluno-conectado-demo.web.app/experience.exe';
const DEMO_WEB_URL = '/demo';

const features = [
  { icon: Monitor, title: 'Interface Completa', desc: 'Dashboard do professor, chamada, avaliacoes e turmas' },
  { icon: Shield, title: 'Offline Total', desc: 'Funciona sem internet — banco SQLite embutido' },
  { icon: Zap, title: 'Zero Instalacao', desc: 'Basta executar o .exe — nenhuma dependencia necessaria' },
  { icon: Building2, title: 'Dados Realistas', desc: 'Escola simulada com alunos, turmas e dados de demonstracao' },
];

export function DownloadPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0f', color: 'white', fontFamily: "'Inter', sans-serif" }}>

      {/* ═══ HERO ═══ */}
      <div style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
        padding: '80px 24px 60px', textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', top: -100, left: '50%', transform: 'translateX(-50%)', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,.15) 0%, transparent 70%)' }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: 720, margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 16px', borderRadius: 20, background: 'rgba(99,102,241,.15)', border: '1px solid rgba(99,102,241,.3)', marginBottom: 20 }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6366f1', animation: 'pulse 2s infinite' }} />
            <span style={{ fontSize: '.78rem', fontWeight: 600, color: '#a5b4fc' }}>Versao Demo Gratuita</span>
          </div>

          <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3.2rem)', fontWeight: 900, lineHeight: 1.1, margin: '0 0 16px' }}>
            Aluno <span style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Conectado</span>
          </h1>
          <p style={{ fontSize: '1.1rem', color: 'rgba(255,255,255,.5)', maxWidth: 520, margin: '0 auto 32px', lineHeight: 1.6 }}>
            Experimente a plataforma educacional mais completa do Brasil.
            Baixe o demo para Windows ou teste direto no navegador.
          </p>

          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={DOWNLOAD_URL} style={{
              display: 'inline-flex', alignItems: 'center', gap: 10, padding: '14px 32px', borderRadius: 14,
              background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white', fontWeight: 700,
              fontSize: '1rem', textDecoration: 'none', border: 'none', cursor: 'pointer',
              boxShadow: '0 0 30px rgba(99,102,241,.4)', transition: 'transform .2s, box-shadow .2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 0 40px rgba(99,102,241,.6)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 0 30px rgba(99,102,241,.4)'; }}
            >
              <Download size={20} /> Baixar para Windows
            </a>

            <a href={DEMO_WEB_URL} style={{
              display: 'inline-flex', alignItems: 'center', gap: 10, padding: '14px 32px', borderRadius: 14,
              background: 'rgba(255,255,255,.06)', color: 'white', fontWeight: 600,
              fontSize: '1rem', textDecoration: 'none', border: '1px solid rgba(255,255,255,.1)',
              cursor: 'pointer', transition: 'background .2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,.06)'; }}
            >
              <ExternalLink size={18} /> Testar no Navegador
            </a>
          </div>

          <p style={{ fontSize: '.78rem', color: 'rgba(255,255,255,.3)', marginTop: 16 }}>
            Windows 10/11 • ~25 MB • Nenhuma instalacao necessaria
          </p>
        </div>
      </div>

      {/* ═══ FEATURES ═══ */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '60px 24px' }}>
        <h2 style={{ fontSize: '1.4rem', fontWeight: 800, textAlign: 'center', marginBottom: 40 }}>
          O que esta incluso no Demo
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20 }}>
          {features.map((f, i) => (
            <div key={i} style={{
              padding: 24, borderRadius: 16, background: 'rgba(255,255,255,.03)',
              border: '1px solid rgba(255,255,255,.06)', transition: 'border-color .3s, background .3s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(99,102,241,.3)'; e.currentTarget.style.background = 'rgba(99,102,241,.05)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,.06)'; e.currentTarget.style.background = 'rgba(255,255,255,.03)'; }}
            >
              <div style={{ width: 44, height: 44, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(99,102,241,.1)', color: '#818cf8', marginBottom: 14 }}>
                <f.icon size={22} />
              </div>
              <h3 style={{ fontSize: '.95rem', fontWeight: 700, margin: '0 0 6px' }}>{f.title}</h3>
              <p style={{ fontSize: '.82rem', color: 'rgba(255,255,255,.45)', margin: 0, lineHeight: 1.5 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ═══ INSTRUCOES ═══ */}
      <div style={{ maxWidth: 600, margin: '0 auto', padding: '0 24px 60px' }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 800, textAlign: 'center', marginBottom: 28 }}>
          Como usar
        </h2>
        {[
          { step: '1', text: 'Baixe o arquivo experience.exe' },
          { step: '2', text: 'Execute o arquivo (pode aparecer aviso do SmartScreen — clique "Executar assim mesmo")' },
          { step: '3', text: 'O navegador abrira automaticamente em localhost:8080' },
          { step: '4', text: 'Explore a plataforma com dados de demonstracao pre-carregados' },
        ].map((s, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '14px 0', borderBottom: i < 3 ? '1px solid rgba(255,255,255,.06)' : 'none' }}>
            <div style={{ width: 32, height: 32, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(99,102,241,.12)', color: '#818cf8', fontSize: '.8rem', fontWeight: 800, flexShrink: 0 }}>
              {s.step}
            </div>
            <span style={{ fontSize: '.88rem', color: 'rgba(255,255,255,.7)' }}>{s.text}</span>
            <ChevronRight size={14} style={{ color: 'rgba(255,255,255,.2)', marginLeft: 'auto' }} />
          </div>
        ))}
      </div>

      {/* ═══ FOOTER ═══ */}
      <div style={{ textAlign: 'center', padding: '30px 24px', borderTop: '1px solid rgba(255,255,255,.06)' }}>
        <a href="/" style={{ color: 'rgba(255,255,255,.3)', fontSize: '.8rem', textDecoration: 'none' }}>
          &larr; Voltar ao site
        </a>
        <p style={{ color: 'rgba(255,255,255,.2)', fontSize: '.72rem', marginTop: 8 }}>
          &copy; 2026 Aluno Conectado — Programa Escola Segura e Inteligente
        </p>
      </div>
    </div>
  );
}
